const sipsic = {
  C003Psicologos: 'SIPSIC/Catalogos/GetPsicologos',
  C009Areas: 'SIPSIC/Catalogos/GetAreas',
  C004EstatusDeDictamen: 'SIPSIC/Catalogos/GetEstatusDeDictamen',
  C006EstatusCita: 'SIPSIC/Catalogos/GetEstatusCita',
  C010TiposPlantillas: 'SIPSIC/Catalogos/GetTiposPlantillas',
  C012TemasEvaluaciones: 'SIPSIC/Catalogos/GetTemasEvaluaciones',
  C013SalasLudicas: 'SIPSIC/Catalogos/GetSalasLudicas'
};

export default sipsic;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIPSIC/catalogos/sipsic.js
// module id = null
// module chunks = 